var map = {
	"./data21.json": 7643,
	"./data22.json": 8154,
	"./data23.json": 5317,
	"./data24.json": 5812,
	"./data25.json": 3847,
	"./data31.json": 1194,
	"./data32.json": 411,
	"./data41.json": 2829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4453;